import { FACADE_CALCULATE_AMOUNT, LEVEL_BOTTOM, LEVEL_TOP } from "common-code/lib/constants";
import { IFacadeData } from "../../../../../common-code/interfaces/materials/IFacadeData";
import { TFacadeCalculateType } from "common-code/lib/types/TFacadeCalculateType";
import {Option} from '@yandex/ui/Select';
import {IHandleData} from '../../../../../common-code/interfaces/materials/IHandleData';
import {IFacadeMaterialData} from '../../../../../common-code/interfaces/materials/IFacadeMaterialData';
import {INewFacadeData} from './FormFacade';

export const levels = [
    { value: LEVEL_BOTTOM, content: "Нижний уровень" },
    { value: LEVEL_TOP, content: "Верхний уровень" },
  ];
  
export const calculateTypes = [
    { value: "amount", content: "Расчет суммарной стоимости группы фасадов" },
    { value: "none", content: "Без расчета стоимости" },
    { value: "self_amount", content: "Расчет стоимости каждого фасада поштучно" },
  ];

export const initialErrors = {
    title: "",
    depth: "",
    image: "",
    models: "",
    offers: "",
}
    
export const defaultValues = (item: IFacadeData | null): INewFacadeData =>{
    
    return item ? {
        id: item.id,
        title: item.title,
        depth: item.depth ? item.depth : 16,
        calculateType: item.calculateType ? item.calculateType : FACADE_CALCULATE_AMOUNT,
        models: item.models ? item.models : [],
        offers: item.offers ? item.offers : [],

        handle: item.handle ? item.handle : undefined,
        level: item.level ? item.level :  undefined,
        isDefault: item.isDefault ? item.isDefault : false,
        disable: item.disable ? item.disable : false,
        image: item.image ? item.image : '',
        imageNew: null,
        plinthMaterial: item.plinthMaterial ? item.plinthMaterial : '',
        isTopFlipY: item.isTopFlipY ? item.isTopFlipY : false,
        isBottomFlipY: item.isBottomFlipY ? item.isBottomFlipY : false,
        isCross: item.isCross ? item.isCross : false,
        kitHandle: item.kitHandle ? item.kitHandle : undefined,
        availableHandles: item.availableHandles ? item.availableHandles : undefined,
    } : {
        id: '',
        title: '' , 
        depth: 16,
        calculateType: FACADE_CALCULATE_AMOUNT as TFacadeCalculateType,
        models: [],
        offers: [],

        handle: undefined,
        level: undefined,
        isDefault: false,
        disable: false,
        image: '',
        imageNew: null,
        plinthMaterial: '',
        isTopFlipY: false,
        isBottomFlipY: false,
        isCross: false,
    }
}

export const getHandlesOptions = (handles?: IHandleData[], withEmpty?: boolean): Option[] => {
    let options: Option[] = [];
    let handle: IHandleData;

    if (handles) {
        for (handle of handles) {
            options.push({value: handle.id, content: handle.title})
        }
    }
    if (withEmpty) {
        options.push({value: 'none', content: 'Не устанавливать'})
    }

    return options;
}

export const getFacadeOptions = (facades?: IFacadeData[], withEmpty?: boolean): Option[] => {
    let options: Option[] = [];
    let facade: IFacadeData;

    if (facades) {
        for (facade of facades) {
            options.push({value: facade.id, content: facade.title})
        }
    }
    if (withEmpty) {
        options.push({value: 'none', content: 'Не устанавливать'})
    }

    return options;
}

export const getFacadeMaterialOptions = (
    facadeMaterials?: IFacadeMaterialData[],
    facades?: IFacadeData[],
    withEmpty?: boolean
): Option[] => {
    let options: Option[] = [];
    let facadeMaterial: IFacadeMaterialData;

    if (facadeMaterials) {
        for (facadeMaterial of facadeMaterials) {
            options.push({
                value: facadeMaterial.id,
                content: getFacadeMaterialTitle(facadeMaterial, getFacadeById(facadeMaterial.facade, facades))
            })
        }
    }
    if (withEmpty) {
        options.push({value: 'none', content: 'Не устанавливать'})
    }

    return options;
}

export const getFacadeMaterialTitle = (
    facadeMaterial: IFacadeMaterialData,
    facade?: IFacadeData
): string => {
    let title: string;

    title = facadeMaterial.title;
    if (facade) {
        title += ' (' + facade.title + ')';
    }

    return title;
}

export  const getFacadeById = (
    facadeId?: string,
    facades?: IFacadeData[]
): IFacadeData | undefined => {
    if (facades && facadeId && facadeId.length) {
        return facades.find((facade) => facade.id === facadeId);
    }

    return undefined;
}
